import { render, staticRenderFns } from "./MultiColoredIcon.vue?vue&type=template&id=022e020e&scoped=true&"
import script from "./MultiColoredIcon.vue?vue&type=script&lang=js&"
export * from "./MultiColoredIcon.vue?vue&type=script&lang=js&"
import style0 from "./MultiColoredIcon.vue?vue&type=style&index=0&id=022e020e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e020e",
  null
  
)

export default component.exports